import type { CustomerActivityItem } from '@/api/services/customerActivity';

export function applyMarkRead(items: CustomerActivityItem[], id: string): CustomerActivityItem[] {
  return items.map((item) => (item.id === id ? { ...item, read: true } : item));
}

export function applyMarkAllRead(items: CustomerActivityItem[]): CustomerActivityItem[] {
  return items.map((item) => ({ ...item, read: true }));
}
